<template>
  <div ref="chart" class="gpt-chart-bar"></div>
</template>

<script>
export default {
    name: 'gpt-chart-bar',
    data () {
        return {
            chartData: []
        };
    },
    props: {
        value: {
            type: Array,
            default: function () {
                return [
                    { SERIES: '系列1', CATEGORY: '分类1', VALUE: 11 },
                    { SERIES: '系列1', CATEGORY: '分类2', VALUE: 22 },
                    { SERIES: '系列2', CATEGORY: '分类1', VALUE: 5 },
                    { SERIES: '系列2', CATEGORY: '分类2', VALUE: 23 }
                ];
            }
        }
    },
    watch: {
        value: function () {
            this.chartData = this.value;
            this.renderChart();
        }
    },
    mounted () {
        this.chartData = this.value;
        this.renderChart();
    },
    methods: {
        renderChart () {
            let echarts = this.$echarts;
            let chartDom = this.$refs.chart;
            let myChart = echarts.init(chartDom, 'dark');
            let seriesData = [];
            let categoryData = [];

            this.chartData.forEach(item => {
                if (!seriesData.includes(item.SERIES || '默认系列')) {
                    seriesData.push(item.SERIES || '默认系列');
                }
                if (!categoryData.includes(item.CATEGORY)) {
                    categoryData.push(item.CATEGORY);
                }
            });

            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: seriesData
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: categoryData
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: []
            };

            seriesData.forEach(series => {
                let seriesValue = [];
                categoryData.forEach(category => {
                    let item = this.chartData.find(d => (d.SERIES || '默认系列') === series && d.CATEGORY === category);
                    let value = item ? item.VALUE : 0;
                    seriesValue.push(value);
                });

                let seriesOption = {
                    name: series,
                    type: 'bar',
                    data: seriesValue
                };

                option.series.push(seriesOption);
            });

            myChart.setOption(option);
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-chart-bar {
    position: relative;
    width: 100%;
    height: 30em;
}
</style>
